
export const curriculum = {
  // Hero Section
  programBadge: 'EDUSPACE Problem Solving Class',
  heroTitle: '8주 완성 프로그램',
  heroSubtitle: '초등 4-5학년을 위한 우주 문제해결 학습',
  badge1: '초등 4-5학년',
  badge2: '8주 과정',
  badge3: '7개 우주 주제',
  badge4: '최종 프로젝트',

  // Daily Schedule Section
  dailyScheduleTitle: '주간 학습 구조',
  dailyScheduleSubtitle: '매일 다른 역량을 키우는 체계적인 학습 프로그램',

  monday: '월요일',
  mondayFocus: '학습 기술과 질문하기',
  mondayDescription: '비판적 사고와 효과적인 질문 기법을 배웁니다',

  tuesday: '화요일',
  tuesdayFocus: '탐색과 리서치',
  tuesdayDescription: '정보를 찾고 분석하는 방법을 익힙니다',

  wednesday: '수요일',
  wednesdayFocus: '우주와 문제 해결',
  wednesdayDescription: '실제 우주 문제를 해결하는 프로젝트를 진행합니다',

  thursday: '목요일',
  thursdayFocus: '기술과 제작',
  thursdayDescription: '아이디어를 실제로 만들고 구현합니다',

  friday: '금요일',
  fridayFocus: '글쓰기와 발표',
  fridayDescription: '배운 내용을 정리하고 효과적으로 전달합니다',

  // Weekly Topics Section
  weeklyTopicsTitle: '8주 학습 주제',
  weeklyTopicsSubtitle: '우주 탐사의 모든 영역을 배우는 완전한 커리큘럼',

  // Week 1
  week1Title: '지구 과학',
  week1Description: '실습을 통해 지구의 시스템, 대기, 기후를 탐구합니다',
  week1Day1: '월요일: 지구 시스템 이해하기 - 질문과 탐구',
  week1Day2: '화요일: 기후 데이터 조사 및 리서치',
  week1Day3: '수요일: 환경 문제 해결 프로젝트',
  week1Day4: '목요일: 데이터 시각화 제작',
  week1Day5: '금요일: 발견 내용 발표 및 토론',

  // Week 2
  week2Title: '달',
  week2Description: '달의 위상, 지질을 학습하고 달 기지 임무를 계획합니다',
  week2Day1: '월요일: 달의 특성 탐구하기',
  week2Day2: '화요일: 달 탐사 역사 리서치',
  week2Day3: '수요일: 달 기지 설계 시작',
  week2Day4: '목요일: 3D 모델 제작 및 프로토타입',
  week2Day5: '금요일: 달 기지 계획 발표',

  // Week 3
  week3Title: '우주 탐사 로버',
  week3Description: '화성 탐사 로버를 직접 설계하고 제작하며 테스트합니다',
  week3Day1: '월요일: 로버의 기능과 목적 이해',
  week3Day2: '화요일: 실제 로버 사례 조사',
  week3Day3: '수요일: 로버 설계 및 문제 해결',
  week3Day4: '목요일: 로버 제작 및 프로그래밍',
  week3Day5: '금요일: 로버 테스트 및 발표',

  // Week 4
  week4Title: '화성 탐사',
  week4Description: '거주지, 자원, 생존을 포함한 화성 임무를 계획합니다',
  week4Day1: '월요일: 화성 환경 이해하기',
  week4Day2: '화요일: 화성 탐사 임무 리서치',
  week4Day3: '수요일: 생존 전략 수립',
  week4Day4: '목요일: 화성 기지 모델 제작',
  week4Day5: '금요일: 임무 계획 발표',

  // Week 5
  week5Title: '우주에서의 생활',
  week5Description: '우주비행사들이 우주에서 생활하고 일하며 실험하는 방법을 알아봅니다',
  week5Day1: '월요일: 우주 생활 조건 탐구',
  week5Day2: '화요일: ISS 일상 리서치',
  week5Day3: '수요일: 우주 식량 시스템 설계',
  week5Day4: '목요일: 생명 유지 장치 제작',
  week5Day5: '금요일: 우주 생활 시뮬레이션 발표',

  // Week 6
  week6Title: '별과 은하',
  week6Description: '별의 생애주기, 별자리, 광대한 우주를 탐험합니다',
  week6Day1: '월요일: 별의 종류와 특성 이해',
  week6Day2: '화요일: 은하와 우주 구조 리서치',
  week6Day3: '수요일: 별자리 지도 제작',
  week6Day4: '목요일: 천체 관측 장비 만들기',
  week6Day5: '금요일: 우주 탐험 발표',

  // Week 7
  week7Title: 'AI와 우주 탐사',
  week7Description: '인공지능이 우주 탐사와 이해를 돕는 방법을 배웁니다',
  week7Day1: '월요일: AI 기초 개념 이해',
  week7Day2: '화요일: 우주 탐사에서의 AI 활용 조사',
  week7Day3: '수요일: 간단한 AI 모델 설계',
  week7Day4: '목요일: 우주 데이터 분석 프로젝트',
  week7Day5: '금요일: AI 프로젝트 발표',

  // Week 8
  week8Title: '최종 프로젝트',
  week8Description: '배운 모든 내용을 종합한 우주 임무 프로젝트를 완성합니다',
  week8Day1: '월요일: 프로젝트 주제 선정 및 계획',
  week8Day2: '화요일: 심화 리서치 및 자료 수집',
  week8Day3: '수요일: 프로젝트 제작 및 실험',
  week8Day4: '목요일: 발표 자료 준비',
  week8Day5: '금요일: 최종 발표 및 수료식',

  // Common
  weekLabel: 'Week',
  seeDetails: '자세히 보기',
  collapse: '접기',
  weeklyActivities: '주간 활동:',

  // Program Features Section
  programFeaturesTitle: 'EDUSPACE만의 특별함',
  programFeaturesSubtitle: '문제해결 역량을 키우는 실전 프로젝트 기반 학습',

  feature1Title: '실습 중심 학습',
  feature1Description: '매일 직접 만들고 실험하며 배우는 체험형 수업',

  feature2Title: '소규모 그룹',
  feature2Description: '개별 맞춤 피드백이 가능한 소규모 수업',

  feature3Title: '학습 자료 제공',
  feature3Description: '워크시트, 퀴즈, 프로젝트 가이드 등 완벽한 자료',

  feature4Title: '발표력 향상',
  feature4Description: '매주 발표로 커뮤니케이션 능력 강화',

  // CTA Section
  ctaBadge: '초등 4-5학년 대상',
  ctaTitle: 'EDUSPACE와 함께',
  ctaHighlight: '우주를 탐험하세요',
  ctaSubtitle: '8주 완성 문제해결 프로그램',
  ctaDescription: '지금 신청하고 우주과학자의 꿈을 키워보세요',
  ctaButton1: '프로그램 신청하기',
  ctaButton2: '학생 프로젝트 보기'
};
